import { render, staticRenderFns } from "./InspectionCommentField.vue?vue&type=template&id=bb7738a0&"
import script from "./InspectionCommentField.vue?vue&type=script&lang=js&"
export * from "./InspectionCommentField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports